
export default {
	setCredentials: function(state, user){
		state.username = user.username;
	},
	auth_success: function(state, {user, token, identityId}){
		state.username = user;
		state.siiToken = token;
		state.identityId = identityId;
		state.isloading = false;

		state.auth.status = 'authenticated';
		state.auth.error = undefined;
	},
	auth_init:function(state){
		state.auth.status = undefined;
		state.auth.error = undefined;
		state.isloading = false;
	},
	auth_error: function( state, err = null ){

		state.auth.status = 'error';
		state.auth.error = err;
		state.isloading = false;
	},
	auth_signout: (state)=>{
		state.username = '';
		state.isloading = false;

		state.auth.status = 'not_authenticated';
		state.auth.error = undefined;
	},
	auth_expired: state =>{
		state.username = '';
		state.isloading = false;

		state.auth.status = 'expired';
		state.auth.error = 'La sesión ha expirado.';
	},
	ACT_CANTIDAD: function( state, consultas ){

		state.consultas = consultas;
	},
}